import { Subject } from 'rxjs/Subject';
import { Injectable } from '@angular/core';

@Injectable()
export class UploadService {
    subject$ = new Subject();
    broadcast(content) {
        this.subject$.next(content)
    }
}
